import React from 'react'

import {
  PersonalDetailsStep1Form,
  PersonalDetailsStep1FormValues,
} from './PersonalDetailsStep1Form'

import 'react-datepicker/dist/react-datepicker.css'

import { usePersonalDetailsGoBack } from '@pages/Signup/routes/usePersonalDetailsGoBack'

import { useSignup } from '@context/SignupContext'

import { SignupWarningMessages } from '../../../Components/SignupWarningMessages'
import { PersonalDetailsTemplate } from '../PersonalDetailsTemplate'

interface PersonalDetailsStep1Props {
  onSubmit(values: PersonalDetailsStep1FormValues): void
}

export const PersonalDetailsStep1Page: React.FC<PersonalDetailsStep1Props> = (props) => {
  const { onSubmit } = props

  const { signupData } = useSignup()
  const goBack = usePersonalDetailsGoBack()
  return (
    <PersonalDetailsTemplate step={1} goBack={goBack}>
      <SignupWarningMessages />
      <PersonalDetailsStep1Form
        values={{
          middleName: signupData.values?.middleName,
          firstName: signupData.values?.firstName,
          lastName: signupData.values?.lastName,
          nativeName: signupData.values?.nativeName,
          genderId: signupData.values?.genderId,
          monthOfBirth: signupData.values?.monthOfBirth,
          dayOfBirth: signupData.values?.dayOfBirth,
          yearOfBirth: signupData.values?.yearOfBirth,
        }}
        onSubmit={onSubmit}
      />
    </PersonalDetailsTemplate>
  )
}
